import { useState } from 'react';
import { faqItems } from '@/mocks/movies';

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于被窝影院电影大全免费看的常见疑问解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenId(openId === idx + 1 ? null : idx + 1)}
                className="w-full flex items-center justify-between gap-3 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-2">
                  {item.q}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openId === idx + 1 ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openId === idx + 1 && (
                <div className="px-5 md:px-6 pb-4 md:pb-5">
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}